import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function FAQSection() {

  const faqs = [
    {
      question: "What costs are involved with DailyPay?",
      answer:
        "DailyPay is free to implement and free for employees to sign up. Employees can access their earnings instantly for a flat fixed transfer fee# or within 1-3 business days for no fee. Employees who sign up for the DailyPay Visa Prepaid Card can instantly access their earnings for no fee.*",
    },

    {
      question: "Why is DailyPay the leading provider of On-Demand Pay?",
      answer:
        "DailyPay leads the industry with more than $37 billion in processed On-Demand Pay transfers. In addition to leading the way in processed transactions, we lead the way with the highest enrollment rates in the industry, with an average rate of 34%. We’re also the #1 adopted financial wellness benefit and the second most-adopted voluntary benefit, behind only healthcare.",
    },

    {
      question: "How long does DailyPay take to implement?",
      answer:
        "It can take as little as one week to set up DailyPay. Our system is designed to work seamlessly with a wide range of payroll systems, evidenced by 180+ pre-built integrations and counting. We integrate with many leading payroll providers, and our flexible platform can adapt to various configurations.",
    },
  ];

  // ONLY ONE OPEN
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(index);
  };

  return (
    <section className="w-full bg-[white] py-20">

      <div className="max-w-[1050px] mx-auto px-6">

        {/* HEADING */}
        <h2
          className="
            text-center
            text-[42px]
            lg:text-[46px]
            leading-[1.05]
            text-[#220000]
            font-semibold
            lg:-mt-[60px]
          "
        >
          You Asked, We Answered.
        </h2>

        {/* FAQS */}
        <div className="mt-8">

          {faqs.map((faq, index) => {

            const isOpen = openIndex === index;

            return (

              <div
                key={index}
                className="border-t border-[#dddddd]"
              >

                {/* QUESTION */}
                <button
                  onClick={() => toggleFAQ(index)}
                  className="
                    w-full
                    flex
                    items-center
                    justify-between
                    gap-6
                    py-12
                    lg:py-5
                    font-sans
                    text-left
                    lg:text-center
                  "
                >

                  <h3
                    className="
                      text-[28px]
                      lg:text-[26px]
                      font-bold
                      text-black
                      leading-[1.3]
                    "
                  >
                    {faq.question}
                  </h3>

                  <div className="flex-shrink-0">

                    {isOpen ? (
                      <ChevronUp
                        size={34}
                        className="text-[#220000]"
                      />
                    ) : (
                      <ChevronDown
                        size={34}
                        className="text-[#220000]"
                      />
                    )}

                  </div>

                </button>

                {/* ANSWER */}
                {isOpen && (
                  <div className="pb-12 pr-12">

                    <p
                      className="
                        text-[20px]
                        lg:text-[16px]

                        leading-[1.4]
                        text-black
                        max-w-[900px]
                      "
                    >
                      {faq.answer}
                    </p>

                  </div>
                )}

              </div>
            );
          })}

          {/* LAST BORDER */}
          <div className="border-t border-[#dddddd]" />

        </div>

        {/* FOOTER TEXT */}
        <div className="mt-10">

          <p className="text-[15px] text-[#5c6780]">
            <span className="font-bold">9,10</span> Internal Database,
            March 2025
          </p>

          <p className="mt-3 text-[15px] text-[#5c6780]">
            # Fees vary by employer; login into your DailyPay account
            for more information.
          </p>

        </div>

      </div>

    </section>
  );
}